<!--
 * @Author:
 * @LastEditTime: 2022-04-18 17:00:07
 * @Description:用户管理
-->
<template>
  <el-card class="h-full">
    <div>
      <el-input
        size="small"
        clearable
        placeholder="请输入关键字"
        class="!w-280px mr-10px"
        v-model="keyWord"
      />
      <el-button size="small" type="primary" @click="searchList()">搜索</el-button>
      <el-button size="small" type="primary" @click="addUser()">新增</el-button>
    </div>
    <el-table
      :height="tableHeight"
      class="mt-20px"
      border
      stripe
      :data="tableData"
      @sort-change="sortChangeTable"
    >
      <el-table-column
        label="用户名"
        prop="userName"
        sortable
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="邮箱" prop="email" sortable show-overflow-tooltip></el-table-column>
      <el-table-column
        label="电话"
        prop="phoneNumber"
        sortable
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column width="270" show-overflow-tooltip label="操作">
        <template slot-scope="scope">
          <el-button @click="readDetail(scope.row)" size="mini">查看</el-button>
          <el-button @click="editUser(scope.row)" size="mini">编辑</el-button>
          <el-button size="mini" @click="deleteUser(scope.row.id)">删除</el-button>
          <el-dropdown
            trigger="click"
            @command="($event) => handleCommand($event, scope.row)"
            class="ml-10px"
            size="mini"
          >
            <el-button size="mini">
              更多<i class="el-icon-arrow-right el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="password">重置密码</el-dropdown-item>
              <!-- <el-dropdown-item command="permission">权限配置</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="text-right mt-20px"
      background
      @size-change="searchList()"
      @current-change="findList()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :total="page.pageTotal"
      layout="sizes, total, prev, pager, next, jumper"
      :pager-count="5"
      :page-sizes="[15, 30, 50, 100]"
    >
    </el-pagination>
    <operate-user-dialog
      v-if="showOperateUserDialog"
      :userProps="userProps"
      :userForm="userForm"
      @refreshList="findList"
    ></operate-user-dialog>
    <operate-permission-dialog
      v-if="showPermissionDialog"
      :permissionProps="permissionProps"
    ></operate-permission-dialog>
    <reset-password-dialog
      v-if="showResetPasswordDialog"
      :resetPasswordForm="resetPasswordForm"
      :resetPasswordProps="resetPasswordProps"
    ></reset-password-dialog>
  </el-card>
</template>
<script>
import { UserApi } from '@wiz-api/abp-identity'

const userApi = new UserApi()

const operateUserDialog = () => {
  return import('../components/OperateUserDialog')
}
const operatePermissionDialog = () => {
  return import('../components/OperatePermissionDialog')
}
const resetPasswordDialog = () => {
  return import('../components/ResetPasswordDialog')
}
export default {
  name: 'user',
  components: {
    operateUserDialog,
    operatePermissionDialog,
    resetPasswordDialog,
  },
  data() {
    return {
      keyWord: '',
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      showOperateUserDialog: false,
      userProps: {
        visible: true,
        title: '新增用户',
        editType: 'create',
      },
      sort: {
        type: '',
        sortName: 'userName',
      },
      userForm: {
        userName: '',
        surname: '',
        name: '',
        password: '',
        confirmPassword: '',
        email: '',
        phoneNumber: '',
        roleNames: [],
        lockoutEnabled: false,
        isActive: false,
      },
      showPermissionDialog: false,
      permissionProps: {
        visible: true,
        providerKey: '',
        providerName: 'U',
        title: '操作用户权限',
      },
      showResetPasswordDialog: false,
      resetPasswordForm: {
        password: '',
        confirmPassword: '',
      },
      resetPasswordProps: {
        visible: true,
        title: '重置密码',
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 106px)'
    },
  },
  methods: {
    handleCommand(command, row) {
      if (command === 'password') {
        this.resetPassWord(row)
      } else {
        this.editPermission(row)
      }
    },
    /**
     * @description: 重置密码
     * @param {*} row
     * @return {*}
     */
    resetPassWord(row) {
      this.showResetPasswordDialog = true
      this.resetPasswordProps = this.$options.data().resetPasswordProps
      this.resetPasswordForm = row
      this.$set(this.resetPasswordForm, 'password', '')
      this.$set(this.resetPasswordForm, 'confirmPassword', '')
    },
    /**
     * @description: 修改用户权限
     * @param {*} row
     * @return {*}
     */
    editPermission(row) {
      this.showPermissionDialog = true
      this.permissionProps = this.$options.data().permissionProps
      this.$set(this.permissionProps, 'providerKey', row.id)
    },
    sortChangeTable(sortColumn) {
      if (_.isNil(sortColumn.column)) {
        return
      }
      this.sort.type = sortColumn.order === 'ascending' ? 0 : 1
      this.sort.sortName = sortColumn.prop
      this.findList()
    },
    async findList() {
      const [err, res] = await userApi.getList({
        filter: this.keyWord,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        sorting: `${this.sort.sortName} ${this.sort.type === 0 ? 'asc' : 'desc'}`,
      })
      if (!err) {
        this.tableData = res.items
        this.page.pageTotal = res.totalCount
      }
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    /**
     * @description: 新增用户
     * @param {*}
     * @return {*}
     */
    addUser() {
      this.showOperateUserDialog = true
      this.userProps = this.$options.data().userProps
      this.userForm = this.$options.data().userForm
    },
    editUser(row) {
      this.showOperateUserDialog = true
      this.userProps = this.$options.data().userProps
      this.userProps.title = '编辑用户'
      this.userProps.editType = 'edit'
      this.userForm = {
        ...row,
        roleNames: [],
      }
    },
    readDetail(row) {
      this.showOperateUserDialog = true
      this.userProps = this.$options.data().userProps
      this.userProps.title = '查看用户'
      this.userProps.editType = 'read'
      this.userForm = {
        ...row,
        roleNames: [],
      }
    },
    /**
     * @description: 删除用户
     * @param {*} id
     * @return {*}
     */
    deleteUser(id) {
      this.$confirm('确认要删除么', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err] = await userApi.callDelete(id)
        if (!err) {
          this.$message.success('删除成功')
          this.searchList()
        }
      })
    },
  },
  created() {
    this.searchList()
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-card__body {
  height: calc(100%);
}
</style>
